// Where Roadrunner is open, and how far a board reaches, in plain words.
// No dependencies, so the app can import the wording without pulling in h3-js.

/**
 * The service area: the northern Tucson suburbs. Ina Road on the south, Kolb
 * Road on the east, I-10 on the west, and north to take in Oracle and San
 * Manuel. Traced from OpenStreetMap road geometry (September 2026); the I-10
 * edge is simplified to within ~150 m.
 *
 * Only decides who can verify a home. Existing members are unaffected by edits.
 * Vertices are [lat, lng], in order around the edge.
 */
export const SERVICE_AREA: readonly (readonly [number, number])[] = [
  [32.3373, -111.0663], // I-10 at Ina Road
  [32.368, -111.0999], // I-10 northwest along the Marana corridor…
  [32.4, -111.1291],
  [32.491, -111.258],
  [32.524, -111.281],
  [32.632, -111.3722],
  [32.66, -111.4102], // …to the northern edge
  [32.66, -110.59], // east past San Manuel
  [32.5, -110.59], // south of Oracle and San Manuel
  [32.5, -110.8443], // back west to Kolb Road's line
  [32.3373, -110.8443], // Kolb Road's line at Ina Road
];

export const SERVICE_AREA_DESCRIPTION =
  'the northern Tucson suburbs: north of Ina Road, between I-10 and Kolb Road, up to Oracle and San Manuel';

/** How far a board reaches, for UI copy. Deliberately plain ("a few miles", not a number); revisit if FEED_RING in geo.ts changes a lot. */
export const FEED_REACH = 'a few miles';

/** Ray-casting point-in-polygon test. Fine at this scale; no projection needed. */
export function isInServiceArea(lat: number, lng: number): boolean {
  let inside = false;
  for (let i = 0, j = SERVICE_AREA.length - 1; i < SERVICE_AREA.length; j = i++) {
    const [latI, lngI] = SERVICE_AREA[i]!;
    const [latJ, lngJ] = SERVICE_AREA[j]!;
    const crosses = lngI > lng !== lngJ > lng && lat < ((latJ - latI) * (lng - lngI)) / (lngJ - lngI) + latI;
    if (crosses) inside = !inside;
  }
  return inside;
}
